<template>
    <ac-modal :title="'Patient Agreement'" ref="modal" @ac-modal-closed="cancelPromise">
        <template>
            <div class="row" v-if="widgetReady">
                <h5 class="col-xs-12">Patient Agreement(s)</h5>
                <div class="col-md-12">
                    <contracts :consumer-id="consumerId"
                               :contracts="contracts"
                               :shopping-cart-items="itemsInCart"
                               @contracts-accepted="accept">
                        <template slot="buttons">
                            <ac-button type="button" class="btn btn-red btn-sm" :action="cancel">CANCEL</ac-button>
                        </template>
                    </contracts>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {common} from "../../../global/common.js";
    import {mapGetters} from "vuex";
    import Contracts from "./Contracts.vue";

    export default {
        name: "ContractsModal",
        components: {Contracts},
        data() {
            return {
                consumerId: null,
                contracts: [],
                resolveRef: null,
                widgetReady: false,
            }
        },
        computed: {
            ...mapGetters(["itemsInCart"])
        },
        watch: {
            itemsInCart(state) {
                this.initOrReload();
            }
        },
        methods: {
            showIfNeeded(consumerId) {
                this.widgetReady = false;
                let self = this;
                this.consumerId = consumerId;
                this.widgetReady = true;
                self.resolveRef = null;
                let promise = new Promise(function (resolve, reject) {
                    self.resolveRef = resolve;
                });
                this.initOrReload();
                return promise;
            },
            async initOrReload() {
                this.contracts = await this.getContracts();
                if (this.contracts.length > 0) {
                    this.$refs.modal.open();
                } else {
                    this.resolveRef({proceed: true, contractsData: {contracts: []}});
                }
            },
            async getContracts() {
                let itemsInCart = JSON.stringify(this.itemsInCart);
                let self = this;
                let response = await $.ajax({
                    url: `ConsumerContracts/${self.consumerId}/GetContracts`,
                    contentType: 'application/json',
                    dataType: "json",
                    data: itemsInCart,
                    type: "POST"
                });
                return response.data;
            },
            accept(contractsInfo) {
                this.resolveRef({proceed: true, contractsData: {...contractsInfo}});
                this.resolveRef = () => {
                };
                this.$refs.modal.close();
            },
            cancel() {
                this.$refs.modal.close();
                this.cancelPromise();
            },
            cancelPromise() {
                this.resolveRef({proceed: false, contractsData: {contracts: []}});
            }
        }
    }
</script>

<style scoped>

</style>